import React, { useEffect } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import { helpers, Enums, Constants } from "@shared";
import { DateTime } from "luxon";
import { Calendar, PayOntime } from "@resources";
import classNames from 'classnames';

const ProductSelector = () => {

    const navigate = useNavigate();
    const location = useLocation();

    const {
        state: {
            account,
            actionableInvoice
        }
    } = location;
    const { potDeadline, orgDays } = account;
    const { canPOTEnroll, dueDate } = actionableInvoice;

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const dueMonth = DateTime.fromISO(dueDate);
    const { maxDay, autodrawDay } = helpers.getDaysFromPayor(orgDays);

    const selectOption = (idProductType) => {

        let flow, invoicePayors;
        const { products, ...rest } = actionableInvoice;

        let feeRule, feeTotal, sunboundTotal, subTotal;
        if (idProductType === Enums.ProductType.SunboundPay) {
            flow = Constants.Flows.advance.id;
            ({ pot: { enrolledPayors: invoicePayors, feeRule, feeTotal, sunboundTotal, subTotal } } = products);
        } else {
            flow = Constants.Flows.gateway.id;
            ({ gateway: { enrolledPayors: invoicePayors, feeRule, feeTotal, sunboundTotal, subTotal } } = products);
        }
        const updatedInvoice = { ...rest, total: undefined, subTotal, feeRule, feeTotal, sunboundTotal };

        helpers.navigateNext(location, navigate, {
            skipPayors: invoicePayors.length > 1,
            enroll: true
        }, {
            account,
            idProductType,
            flow,
            invoicePayors,
            invoice: updatedInvoice
        });
    };

    const payOverTimeCSS = classNames(`flex flex-row p-5 gap-x-3 justify-between rounded-xl border-2 border-gray-200 w-full `, { "cursor-pointer bg-sb-bg": canPOTEnroll }, { "bg-gray-300": !canPOTEnroll });

    return (
        <div className="page-content-wrapper">
            <h1 className="page-header">Payment timeline</h1>
            <div className="mt-4 flex flex-col gap-y-8">
                <div className={payOverTimeCSS} onClick={() => canPOTEnroll && selectOption(Enums.ProductType.SunboundPay)}>
                    <div className="flex flex-col">
                        <span className="font-bold text-lg">Advance my rent</span>
                        <span>Extend your due date to <b>{`${dueMonth.toFormat(`MMMM`)} ${helpers.dayOrdinal(potDeadline)}`}</b> and pay in your preferred number of installments. Pay just a 1% fee and eliminate paying a late fee!</span>
                        {
                            canPOTEnroll &&
                            <div className="mt-3">
                                <span className="font-semibold">To get access to pay over time, be sure to enroll before the {helpers.dayOrdinal(maxDay)} of next month</span>
                            </div>
                        }
                    </div>
                    <Calendar className="w-32 flex-none" />
                </div>
                <div className="flex flex-row bg-sb-bg p-5 gap-x-3 justify-between rounded-xl border-2 border-gray-200 w-full cursor-pointer" onClick={() => selectOption(Enums.ProductType.Gateway)}>
                    <div className="flex flex-col">
                        <span className="font-bold text-lg">Pay by the {helpers.dayOrdinal(autodrawDay)}</span>
                        <span>Pay rent by the current due date of <b>{`${dueMonth.toFormat(`MMMM`)} ${helpers.dayOrdinal(autodrawDay)}`}</b></span>
                    </div>
                    <PayOntime className="w-32 flex-none" />

                </div>
            </div>
        </div >
    );
};

export default ProductSelector;